import { render, staticRenderFns } from "./VatInvoiceV2.vue?vue&type=template&id=e99045fc&scoped=true"
import script from "./VatInvoiceV2.vue?vue&type=script&lang=js"
export * from "./VatInvoiceV2.vue?vue&type=script&lang=js"
import style0 from "./VatInvoiceV2.vue?vue&type=style&index=0&id=e99045fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e99045fc",
  null
  
)

export default component.exports